import { z } from 'zod';

export const masterClassSchema = z.object({
  caseIntroVideoRef: z.string().min(1).optional(),
  slideMap: z.record(
    z.string().min(1),
    z.object({
      introVideoRef: z.string().min(1).optional(),
      outroVideoRef: z.string().min(1).optional(),
    })
  ),
  questionMap: z.record(
    z.string().min(1),
    z.object({
      correctAnswerIds: z.array(z.string().min(1)),
    })
  ),
  answerMap: z.record(
    z.string().min(1),
    z.object({
      videoRef: z.string().min(1).nullable(),
    })
  ),
});
